const hostname = document.location.hostname ? document.location.hostname : window.location.hostname;

export const GOOGLE_VERIFICATION_CODE = [
  'www.acmilan-web-prod.netcosports.com', 'acmilan-web-prod.netcosports.com', // NETCO HOSTS - LIVE PROD ENV MIRACLE
  'www.acmilan-web-integ.netcosports.com', 'acmilan-web-integ.netcosports.com', // NETCO HOSTS - QA STAGE ENV
  'localhost', // LOCAL HOSTS - DEV ENV
].includes(hostname)
  ? '-qippvTrC3BDCqo98-Wok808VgAiiWC3yLjjhP3ay4M' // NETCO HOSTS - PROD & STAGE ENV
  : 'iSd_rDmuW4Y8CbBg_WTvkbmbOz3yVeMyqJJ2M'; // MILAN HOSTS - LIVE PROD ENV
